import * as React from "react";
import FlatButton from "material-ui/FlatButton";
import { fullWhite } from "material-ui/styles/colors";
import KeyboardArrowLeft from "material-ui/svg-icons/hardware/keyboard-arrow-left";
import KeyboardArrowRight from "material-ui/svg-icons/hardware/keyboard-arrow-right";
import ZoomIn from "material-ui/svg-icons/action/zoom-in";
import ZoomOut from "material-ui/svg-icons/action/zoom-out";
import ResizeScale from "material-ui/svg-icons/action/aspect-ratio";
import {Col, Row} from "react-bootstrap";
import "./NavegadorPDF.css";

class NavegadorPDF extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    render() {
        return(
            <div className='navegador-estilo'>
                <Row>
                    <Col sm={4}>
                        {this.ZoomOutBtn()}
                        {this.ZoomInBtn()}
                    </Col>
                    <Col sm={4}>
                        {this.PaginaAnteriorBtn()}
                        {`Página ${this.props.indexPagina} / ${this.props.totalPaginas}`}
                        {this.PaginaSiguienteBtn()}
                    </Col>
                    <Col sm={3}>
                        {this.ResizeScaleBtn()}
                    </Col>
                </Row>
            </div>
        );
    }

    PaginaAnteriorBtn() {
        if (this.props.indexPagina === 1) {
            return (
                <FlatButton 
                    style={{margin: 8}} 
                    icon={<KeyboardArrowLeft color={fullWhite}/>} 
                    disabled
                />
            );
        }
        return(
            <FlatButton
                style={{margin: 8}} 
                icon={<KeyboardArrowLeft color={fullWhite}/>}
                onClick={this.eventoPaginaPrevia}
            />
        );
    }

    ZoomOutBtn() {
        if (this.props.zoomPagina <= this.props.zoomMin) {
            return (
                <FlatButton
                    style={{margin: 8}} 
                    icon={<ZoomOut color={fullWhite}/>}
                    disabled
                />
            );
        }
        return (
            <FlatButton
                title={"Reducir"}
                style={{margin: 8}} 
                icon={<ZoomOut color={fullWhite}/>}
                onClick={this.eventZoomOut}
            /> 
        ); 
    }

    ZoomInBtn() {
        if (this.props.zoomPagina >= this.props.zoomMax) {
            return (
                <FlatButton
                    style={{margin: 8}} 
                    icon={<ZoomIn color={fullWhite}/>}
                    disabled
                />
            );
        }
        return (
            <FlatButton
                title={"Acercar"}
                style={{margin: 8}} 
                icon={<ZoomIn color={fullWhite}/>}
                onClick={this.eventZoomIn}
            />
        );
    }

    PaginaSiguienteBtn() {
        if (this.props.indexPagina === this.props.totalPaginas) {
            return (
                <FlatButton 
                    style={{margin: 8}} 
                    icon={<KeyboardArrowRight color={fullWhite}/>} 
                    disabled
                />
            );
        }
        return(
            <FlatButton 
                style={{margin: 8}} 
                icon={<KeyboardArrowRight color={fullWhite}/>}
                onClick={this.eventoPaginaSiguiente}
            />
        );
    }

    ResizeScaleBtn() {
        return (
            <FlatButton
                title={"Ajustar tamaño de página"}
                style={{margin: 8}} 
                icon={<ResizeScale color={fullWhite}/>}
                onClick={this.eventResizeScale}
            />
        );
    }

    eventoPaginaPrevia = () => {
        this.props.eventoPaginaPrevia();
    }
    
    eventoPaginaSiguiente = () => {
        this.props.eventoPaginaSiguiente();
    }

    eventZoomIn = () => {
        this.props.eventZoomIn();
    }
    
    eventZoomOut = () => {
        this.props.eventZoomOut();
    }

    eventResizeScale = () => {
        this.props.eventResizeScale();
    }
}

export default NavegadorPDF;


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/NavegadorPDF.tsx